import {v4 as uuid} from "uuid";
import {NodeFileSearchControl} from "../../controls";
import {RemoveButtonControl} from "../../controls/RemoveButtonControl";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import Rete from "rete";
import {tempActionSocket} from "../../sockets";
import {SequenceComponent} from "../SequenceComponent";
import {ResourceType} from "models/ResourceType";

export class Avatar {

    constructor(parentComponent, avatarAdded, avatarRemoved) {
        this.parentComponent = parentComponent;
        this.onAvatarAdded = avatarAdded;
        this.onAvatarRemoved = avatarRemoved;
        this.isAdded = false;
    }

    addAvatar(node, avatarUUID = null) {
        if (avatarUUID == null) {
            avatarUUID = uuid();
        }

        const animationFileControl = new NodeFileSearchControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getAvatarAnimationFileKey(avatarUUID),
            node,
            ResourceType.AvatarAnimation,
            false,
            "Animation file (optional)"
        );

        const output = new Rete.Output(
            SequenceComponentHelper.getAvatarOutputKey(avatarUUID),
            "Action",
            tempActionSocket,
            false
        );

        const removeAvatarControl = new RemoveButtonControl(
            this.parentComponent.editor,
            SequenceComponentHelper.getAvatarRemoveButtonKey(avatarUUID),
            node,
            false,
            () => this.onRemoveAvatarClick.bind(this, node, avatarUUID, removeAvatarControl, animationFileControl, output)
        );

        node
            .addControl(removeAvatarControl)
            .addControl(animationFileControl)
            .addOutput(output);

        this.avatarAdded(node, avatarUUID);
        node.update();
    }

    avatarAdded(node, addedAvatarUUID) {
        node.avatarId = addedAvatarUUID;
        this.isAdded = true;
        this.onAvatarAdded();
    }

    onRemoveAvatarClick(node, avatarUUID, removeAvatarControl, animationFileControl, outputControl) {
        this.removeAvatar(node, avatarUUID, removeAvatarControl, animationFileControl, outputControl)
            .then(r => {
                this.avatarRemoved(node, avatarUUID);
            });
    }

    async removeAvatar(node, avatarUUID, removeAvatarControl, animationFileControl, outputControl) {
        node.removeControl(removeAvatarControl);
        node.removeControl(animationFileControl);

        outputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
        node.removeOutput(outputControl);

        node.update();

        this.parentComponent.editor.view.updateConnections({node});

        delete node.data[SequenceComponentHelper.getAvatarAnimationFileKey(avatarUUID)];
    }

    async avatarRemoved(node, avatarUUID) {
        node.avatarId = null;
        this.isAdded = false;
        this.onAvatarRemoved();
    }

    handleAnswerAdded(node) {
        this.removeOutputConnections(node);
    }

    handleAnswerRemoved(node) {
        if (!this.isAdded) return;
        node.update();
    }

    handleTextSlideAdded(node) {
        this.removeOutputConnections(node);
    }

    handleTextSlideRemoved(node) {
        if (!this.isAdded) return;
        node.update();
    }

    removeOutputConnections(node) {
        if (!this.isAdded) return;

        let avatarOutputControl = null;
        node.outputs.forEach(output => {
            const outputKey = output.key.split('_');
            if (outputKey[1] === SequenceComponent.AVATAR_CHILD_COMPONENT_KEY) {
                if (avatarOutputControl) throw new Error("Avatar component cannot handle multiple outputs.");
                avatarOutputControl = output;
            }
        });

        if (avatarOutputControl.connections.length > 0) {
            avatarOutputControl.connections.map(connection => this.parentComponent.editor.removeConnection(connection));
            node.update();
            this.parentComponent.editor.view.updateConnections({node});
        }
    }
}
